"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsFeatureCollection = void 0;
const useModelsQuery_1 = require("./useModelsQuery");
function useModelsFeatureCollection(accountNumber, id) {
    return useModelsQuery_1.useModelsQuery(`/feature-collections/${id}/geojson`, accountNumber);
}
exports.useModelsFeatureCollection = useModelsFeatureCollection;
//# sourceMappingURL=useModelsFeatureCollection.js.map